import type { WProfileView } from '@zola/svc-web-api-ts-client';

export const REQUEST_DASHBOARD = 'zola/dashboard/REQUEST_DASHBOARD';
export const RECEIVE_DASHBOARD = 'zola/dashboard/RECEIVE_DASHBOARD';

type RequestDashboardActionType = {
  type: typeof REQUEST_DASHBOARD;
};

type ReceiveDashboardActionType = {
  type: typeof RECEIVE_DASHBOARD;
  payload: WProfileView;
};

export type DashboardActionTypes = RequestDashboardActionType | ReceiveDashboardActionType;



// WEBPACK FOOTER //
// ./src/actions/types/DashboardActionTypes.ts